<template>
  <main class="main">
    <div class="anim-wrap" v-if="userData">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <PersonalityUserCard
              :firstName="userData.firstName"
              :lastName="userData.lastName"
              :personality="userData.personality"
            />
          </div>
          <div class="col-md-7">
            <PersonalitySplitCard :personality="userData.personality" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <PersonalityHighsAndLowsCard :personality="userData.personality" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import { db } from "../main.js";

import PersonalityUserCard from "@/components/PersonalityUserCard";
import PersonalitySplitCard from "@/components/PersonalitySplitCard";
import PersonalityHighsAndLowsCard from "@/components/PersonalityHighsAndLowsCard";

export default {
  name: "report",
  components: {
    PersonalityUserCard,
    PersonalitySplitCard,
    PersonalityHighsAndLowsCard
  },
  computed: {},
  data() {
    return {
      userData: null
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let hash = this.$router.currentRoute.hash;

      if (!hash) {
        return;
      }

      let userId = hash.replace("#", "");
      var docRef = db
        .collection("users")
        .doc(userId)
        .collection("shared")
        .doc(userId);
      docRef
        .get()
        .then(doc => {
          if (doc.exists) {
            this.userData = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    }
  }
};
</script>
